import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { APPLICATION_GLOBAL_SLUG, createMarkup, APPLICATION_NAME, replaceNbsp } from "src/_config";
import { useCmsApi } from "src/_common/hooks/actions/cms/cmsApiHook";
import { toast } from "react-toastify";
import Sponsor from "../common/Sponsor";

export default function CmsPage() {
  const cmsApi = useCmsApi();
  const [content, setContent] = useState<any>();
  const { slug } = useParams<any>();

  const getCmsContentDetails = () => {
    var params = {
      game_slug: APPLICATION_GLOBAL_SLUG,
      slug,
    };

    cmsApi.callGetCmsContent(
      params,
      (message: string, resp: any) => {
        if (resp && resp.list) {
          setContent(resp.list);
        } else {
          setContent("");
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  useEffect(() => {
    if (content) {
      const prevTitle = document.title;
      document.title = `${APPLICATION_NAME} : ${content.title}`;
      return () => {
        document.title = prevTitle;
      };
    }
  }, [content]);

  useEffect(() => {
    getCmsContentDetails();
  }, []);

  return (
    <React.Fragment>
      <div className="main-content-panel">
        <div className="pt-3">
          <h3 className="section-heading mb-3">{content?.title}</h3>
          <p
            dangerouslySetInnerHTML={createMarkup(
              content && content.long_description ? replaceNbsp(content.long_description) : "No content added!"
            )}
          />
        </div>
      </div>
      <Sponsor />
    </React.Fragment>
  );
}
